import { createFileRoute } from "@tanstack/react-router"
import BackofficeOutlookReader from "modules/backoffice/components/outlookReader"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/backoffice/outlookReader")({
  component: BackofficeOutlookReader,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("backoffice.outlookReader.title"),
    })
  },
})
